import angular from 'angular';

(function() {
    'use strict';

    angular.module('app').filter('capitalize', capitalize)
    .filter('handlePccDisplay', handlePccDisplay)

    function capitalize() {
        return function(input) {
            return !!input
                ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase()
                : '';
        };
    }

    function handlePccDisplay($sce) {
        return function(value, pre, suf) {
            if (value) {
                return value ? pre + value.substr(-10) : '';
            } else {
                return $sce.trustAsHtml(
                    "<span class='text-italic low-opacity'>None</span>"
                );
            }
        };
    }


})();



// WEBPACK FOOTER //
// ./src/app/filters/capitalize.filter.js